"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeRangesRule = exports.ptnRangesConnectors = void 0;
const factory_1 = __importDefault(require("../factory"));
const _sentenceChildren_1 = require("./$sentenceChildren");
const simpleRangeMaker = (from, midText, to) => {
    void midText;
    return [from, to ?? from];
};
const simpleRangesMaker = (first, midText, rest) => {
    void midText;
    return {
        value: [first.value, ...(rest?.value ?? [])],
        errors: [...first.errors, ...(rest?.errors ?? [])],
    };
};
exports.ptnRangesConnectors = ["、", "及び", "及ビ", "及(?!至)", "および", "並びに", "ならびに", "又は", "または", "若しくは", "もしくは"];
const reRangesConnector = new RegExp(`^(${exports.ptnRangesConnectors.join("|")})`); // no $
const makeRangesRule = (lazyPointerRule, rangeMaker = simpleRangeMaker, rangesMaker = simpleRangesMaker) => {
    const $ranges = factory_1.default
        .withName("ranges")
        .choice(c => c
        .or(r => r
        .sequence(c => c
        .and(() => $range, "first")
        .and(r => r
        .sequence(s => s
        .and(r => r.regExp(reRangesConnector))
        .action(({ text, range }) => ({ text: text(), range: range() }))), "midText")
        .and(() => $ranges, "rest")
        .action(({ first, midText, rest, range }) => {
        return rangesMaker(first, midText, rest, range());
    })))
        .or(r => r
        .sequence(c => c
        .and(() => $range, "singleRange")
        .action(({ singleRange, range }) => {
        return rangesMaker(singleRange, null, null, range());
    }))));
    const $range = factory_1.default
        .withName("range")
        .choice(c => c
        .or(r => r
        .sequence(c => c
        .and(lazyPointerRule, "from")
        .and(r => r
        .sequence(s => s
        .and(r => r.seqEqual("から"))
        .action(({ text, range }) => ({ text: text(), range: range() }))), "midText")
        .and(lazyPointerRule, "to")
        .and(r => r
        .sequence(s => s
        .and(r => r.seqEqual("まで"))
        .action(({ text, range }) => ({ text: text(), range: range() }))), "trailingText")
        .and(r => r
        .zeroOrOne(() => _sentenceChildren_1.$ROUND_PARENTHESES_INLINE), "modifierParentheses")
        .action(({ from, midText, to, trailingText, modifierParentheses, range }) => {
        return {
            value: rangeMaker(from, midText, to, trailingText, modifierParentheses?.value ?? null, range()),
            errors: [...(modifierParentheses?.errors ?? [])],
        };
    })))
        .or(r => r
        .sequence(c => c
        .and(lazyPointerRule, "from")
        .and(r => r
        .sequence(s => s
        .and(r => r.regExp(/^(?:・|～|乃至)/))
        .action(({ text, range }) => ({ text: text(), range: range() }))), "midText")
        .and(lazyPointerRule, "to")
        .and(r => r
        .zeroOrOne(() => _sentenceChildren_1.$ROUND_PARENTHESES_INLINE), "modifierParentheses")
        .action(({ from, midText, to, modifierParentheses, range }) => {
        return {
            value: rangeMaker(from, midText, to, null, modifierParentheses?.value ?? null, range()),
            errors: [...(modifierParentheses?.errors ?? [])],
        };
    })))
        .or(r => r
        .sequence(c => c
        .and(lazyPointerRule, "pointer")
        .and(r => r
        .zeroOrOne(() => _sentenceChildren_1.$ROUND_PARENTHESES_INLINE), "modifierParentheses")
        .action(({ pointer, modifierParentheses, range }) => {
        return {
            value: rangeMaker(pointer, null, null, null, modifierParentheses?.value ?? null, range()),
            errors: [...(modifierParentheses?.errors ?? [])],
        };
    }))));
    return { $ranges, $range };
};
exports.makeRangesRule = makeRangesRule;
exports.default = exports.makeRangesRule;
//# sourceMappingURL=makeRangesRule.js.map